import React, {useEffect, useRef, useState} from 'react'
import useInterval from "../../../../customHooks/useInterval";
const MOVE_DIRECTION = {
    up: 'up',
    down: 'down'
}
const TIME_INTERVAL = 100
const CrossingArmFront = props => {
    const [eventActive, setEventActive] = useState(false);
    const [eventOver, setEventOver] = useState(false);
    // ref for starting stopping animation 
    const lightSwitch = useRef(false)
    const intermittentLights = useRef(false)
    const moveCrossingArm = useRef()
 
    const currentTime = useRef(0)
    const eventsToProcess = useRef(props?.data?.timedEvents.map( e => ({ ...e, processed: false})) || [])

    // Arm Animation state/modifiers
    const [crossingArmAnimation, setCrossingArmAnimation ] = useState({
        isAnimating:  false,
        currentState: 0,
        animationSpeed: 100
    })


    function move(direction =  MOVE_DIRECTION.up, top = 6, bottom  = 0) {
        console.log(direction, top, bottom)
        setCrossingArmAnimation((curr) => {
            if (direction === MOVE_DIRECTION.up) {
                if (curr.currentState < top) {
                    return {
                        ...curr,
                        isAnimating: true,
                        currentState: curr.currentState + 1,
                    }
                }
                return {
                    ...curr,
                    isAnimating: false
                }
            }
            if (curr.currentState > bottom ) {
                return {
                    ...curr,
                    isAnimating: true,
                    currentState: curr.currentState - 1,
                }
            }
            return {
                ...curr,
                isAnimating: false
            }

        })
    }

    useEffect( () => {
        const lightSwitchInterval = setInterval(() => {
            if (lightSwitch?.current === true) {
                intermittentLights.current = !intermittentLights.current
            }
        },500)
        const crossingArmInterval = setInterval(() => {
            if (moveCrossingArm.current &&  (moveCrossingArm.current.direction === MOVE_DIRECTION.up || moveCrossingArm.current.direction === MOVE_DIRECTION.down)) {
                const bottom = moveCrossingArm.current.direction === MOVE_DIRECTION.up ? 0 : moveCrossingArm.current.stopAt
                const top = moveCrossingArm.current.direction === MOVE_DIRECTION.up ? moveCrossingArm.current.stopAt : 7
                move(moveCrossingArm.current.direction, top, bottom)
            }
        }, 100)

        setEventActive(true)
        return () => {
            clearInterval(crossingArmInterval)
            clearInterval(lightSwitchInterval)
        }

    }, [])
    
    // Main Timer for TimedEvents
    useInterval( () => {
        if (eventActive && !eventOver) {
            eventsToProcess.current && eventsToProcess.current.forEach((e,i)=> {
                if (e.processed === true) return;
                if (e.time > currentTime.current) return
                eventsToProcess.current[i].processed = true
                switch (e.event) {
                    case 'flash_crossing_lights':
                        if (e.value !== lightSwitch.current) {
                            console.log("FRONT: Switching lights", e.value)
                            lightSwitch.current = (e.value)
                        }
                        break
                    case 'move_crossing_arm':
                        console.log("FRONT: Setting arm to move", e.value)
                        moveCrossingArm.current = e.value

                        break
                  
                    default:
                        console.log(`Unhandled event of type: ${e.event} at ${e.time}`)
                        break
                }
            })
        }
        currentTime.current += TIME_INTERVAL
        // if (currentTime.current % 1000 === 0)
        // console.log("FRONT: ", currentTime.current)
    },TIME_INTERVAL)
    
    return <>
        <div className={'crossing-arm front'}>
            <div className={`base `} />
            <div className={`arm state-${crossingArmAnimation.currentState}`} />
            <div className={`x-sign`} />
            <div className={`track-sign`} />
            <div className={`lights `} />
            <div className={`${lightSwitch.current === true ? 'illumination on' : 'off'} ${lightSwitch?.current === true && intermittentLights.current === true ? 'left' : 'right'} }`} />
        </div>
    </>
}

export default CrossingArmFront;